import React, { Component } from 'react';

import FinancialPlanHeader from '../../FinancialPlanHeaderView';

import ProgressChart from './ProgressChart/ProgressChartContainer';
import { NEEDS_ANALYSIS, INCOME_REPLACEMENT } from './ProgressChart/ProgressChartConstants';
import Explanations from '../../Explanations/ExplanationsContainer';

export default class LifeView extends Component {
  constructor(props) {
    super(props);
    this.onLifeRef = this.onLifeRef.bind(this);
  }

  onLifeRef(element) {
    if (element !== this.container) {
      this.container = element;
    }
  }

  UNSAFE_componentWillReceiveProps(newProps) {}

  render() {
    const {
      isPrint,
      clientId,
      fpId,
      goalId,
      subgoalId,
      note,
      setSelectedOwnerIndex,
      setSelectedTabIndex,
      subgoalData,
      selectedSection,
      selectedOwnerName,
      selectedOwnerIndex,
    } = this.props;
    return (
      <div className="NewFinancialPlan_Insurance_Life" ref={this.onLifeRef}>
        <div
          className={`NewFinancialPlan_header
                ${!this.props.showCalibration ? ' hide-calibration-button' : ''}
            `}
        >
          <FinancialPlanHeader
            {...this.props}
            printTitle={`Life Insurance: ${selectedOwnerName}`}
            hideOldDescription={false}
          />
        </div>

        <section className="calibration" />

        {!isPrint && <Explanations clientId={clientId} />}

        <ProgressChart
          tabs={[NEEDS_ANALYSIS, INCOME_REPLACEMENT]}
          isPrint={isPrint}
          clientId={clientId}
          goalId={goalId}
          fpId={fpId}
          subgoalId={subgoalId}
          subgoalData={subgoalData}
          note={note}
          principalName={subgoalData.PrincipalName}
          spouseName={subgoalData.SpouseName}
          setSelectedOwnerIndex={setSelectedOwnerIndex(clientId, goalId)}
          setSelectedTabIndex={setSelectedTabIndex(clientId, goalId, subgoalId)}
          {...(isPrint ? { ownerIndex: selectedOwnerIndex, tabId: subgoalId } : {})}
        />
      </div>
    );
  }
}
